export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f21d9bd2787424afb5aee9a9a17ddc121abc8b72a&name=fetchTypeahead!'